// extracted by mini-css-extract-plugin
module.exports = {"main":"Stats_main__60Al1","isLoadingStats":"Stats_isLoadingStats__2KlG-"};